export default "__VITE_PUBLIC_ASSET__1e92f05d__"